module.exports = __webpack_public_path__ + "static/img/IMG_2543.97d645d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/gallery/10/IMG_2543.jpg
// module id = 663
// module chunks = 0